import axios, { AxiosError } from "axios";
import { ChangeEvent, FormEvent, SetStateAction, useState } from "react";
import { useNavigate } from "react-router-dom";
import AjouterProduitM from "../../Views/Magasin/HomeMagasin/AjouterProduitM";

export default function AddArticle(){
    const navigate = useNavigate();
    const [Designation, setDesignation] = useState<string>("");
    const [PrixVenteArticleTTC, setPrixVenteArticleTTC] = useState<string>("");
    const [prix_ht_2_magasin, setprix_ht_2_magasin] = useState<string>("");
    const [prix_ht_3_magasin, setprix_ht_3_magasin] = useState<string>("");
    const [prix_ht_1_magasin, setprix_ht_1_magasin] = useState<string>("");
    const [quantité, setquantité] = useState<string>("1");
    const [Description, setDescription] = useState<string>("");
    const [image, setImage] = useState<File | null>(null);
    const [stock, setstock] = useState<string>("");
    const [RefArticle, setRefArticle] = useState<string>("");
    const [Unite, setUnite] = useState<string>("");
    const [messageError, setMessageError] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false); // Loader state
    const [successResult, setSuccessResult] = useState<any>(null);



  const handleImage = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setImage(e.target.files[0]);
    }
  };

  const handleSuccessClose = () => {
    setSuccessResult(null);
    navigate(`/magasins/${localStorage.getItem('MagasinId')}`);
  };

  const handleSubmit = async (e: FormEvent) => {
    const MagasinId = localStorage.getItem('MagasinId');  
    e.preventDefault();
    setLoading(true); // Show loader
    const formData = new FormData();
    formData.append("Designation", Designation);
    formData.append("PrixVenteArticleTTC", prix_ht_1_magasin); // User wants PrixNetHT, we use prix_ht_1_magasin for it
    formData.append("prix2", prix_ht_1_magasin);
    formData.append("prix3", prix_ht_2_magasin);
    formData.append("prix4", prix_ht_3_magasin);
    formData.append("Description", Description);
    formData.append("stock", stock);
    formData.append("Unite", Unite);
    formData.append("Quantity", quantité);
    formData.append("RefArticle", RefArticle);  
    if (image) {
      formData.append("UrlImage", image);
    }
    if (Designation === "") {
      setMessageError("Veuillez saisir le nom de produit");
      setLoading(false);
    } else if (RefArticle === "") {
      setMessageError("Veuillez saisir la référence du produit");
      setLoading(false);

    }else if (prix_ht_1_magasin === "") {
      setMessageError("Veuillez saisir le prix HT du produit");
      setLoading(false);
    }else if (quantité === "") {
      setMessageError("Veuillez saisir la quantité du produit");
      setLoading(false);
    }
    else{

      try {
        await axios.post(`${process.env.REACT_APP_PHP_APP_URL}/magasins/${MagasinId}/articles/add`, formData)
        .then(({data})=>{
          setLoading(false);
          setSuccessResult({ creates: 1, updates: 0, errors: [] });
        });
      } catch (error: AxiosError | any) {
        
          setMessageError('Veuillez saisir toutes les informations')
          setLoading(false); // Hide loader if there's an error
          const timeoutId = setTimeout(() => {
          setMessageError('')
          }, 3000);
  
        } 
    }    
      
    }
    return<>
    <AjouterProduitM
      loading={loading}
        setDesignation={setDesignation}
        Designation={Designation}
        setDescription={setDescription}
        Description={Description}
        setPrixVenteArticleTTC={setPrixVenteArticleTTC}
        PrixVenteArticleTTC={PrixVenteArticleTTC}
        setImage={setImage}
        image={image}
        setQuantité={setquantité}
        setstock={setstock}
        stock={stock}
        setRefARticle={setRefArticle}
        RefArticle={RefArticle}
        setUnite={setUnite}
        Unite={Unite}
        prix_ht_2_magasin={prix_ht_2_magasin}
        prix_ht_3_magasin={prix_ht_3_magasin}
        prix_ht_1_magasin={prix_ht_1_magasin}
        handleSubmit={handleSubmit}
        handleImage={handleImage}
        messageError={messageError}
        setprix_ht_2_magasin={setprix_ht_2_magasin}
        setprix_ht_3_magasin={setprix_ht_3_magasin}
        setprix_ht_1_magasin={setprix_ht_1_magasin}
        successResult={successResult}
        handleSuccessClose={handleSuccessClose}
        setquantité={setquantité} setNomClient={function (value: SetStateAction<string>): void {
          throw new Error("Function not implemented.");
        } } setAdresse={function (value: SetStateAction<string>): void {
          throw new Error("Function not implemented.");
        } } setTotalCommandeHT={function (value: SetStateAction<string>): void {
          throw new Error("Function not implemented.");
        } } setTotalRemise={function (value: SetStateAction<string>): void {
          throw new Error("Function not implemented.");
        } }    />
    </>
}
